export const MISSION_TYPES = [
  { value: "commissariat_comptes", label: "Commissariat aux comptes" },
  { value: "tenue_comptable", label: "Tenue comptable & déclarations fiscales" },
  { value: "liasse_fiscale", label: "Liasse fiscale" },
  { value: "creation_societe", label: "Création de société" },
  { value: "modification_societe", label: "Modification de société" },
  { value: "dissolution_societe", label: "Dissolution de société" },
  { value: "audit_projet_afrique", label: "Audit de projet en Afrique" },
  { value: "audit_association", label: "Audit d'association" },
  { value: "conseil", label: "Mission de conseil" },
];

export const missionLabel = (v) => MISSION_TYPES.find((m) => m.value === v)?.label || v;

export const ROLES = [
  { value: "admin", label: "Administrateur" },
  { value: "expert", label: "Expert-Comptable" },
  { value: "collab_fr", label: "Collaborateur France" },
  { value: "collab_cm", label: "Collaborateur Cameroun" },
];
export const roleLabel = (v) => ROLES.find((r) => r.value === v)?.label || v;

export const TIME_CATEGORIES = [
  { value: "facturable", label: "Facturable" },
  { value: "administratif", label: "Administratif" },
  { value: "commercial", label: "Commercial" },
  { value: "formation", label: "Formation" },
  { value: "absence", label: "Absence" },
];
export const categoryLabel = (v) => TIME_CATEGORIES.find((c) => c.value === v)?.label || v;

export const MISSION_STATUS = [
  { value: "prospection", label: "Prospection" },
  { value: "en_cours", label: "En cours" },
  { value: "en_revue", label: "En revue" },
  { value: "clos", label: "Clos" },
];

export const QC_STATUS = [
  { value: "a_relire", label: "À relire" },
  { value: "en_relecture", label: "En relecture" },
  { value: "valide", label: "Validé" },
  { value: "rejete", label: "Rejeté" },
];
export const qcStatusLabel = (v) => QC_STATUS.find((s) => s.value === v)?.label || v;

export const QC_DOC_TYPES = [
  { value: "lettre_mission", label: "Lettre de mission" },
  { value: "programme_travail", label: "Programme de travail" },
  { value: "rapport_audit", label: "Rapport d'audit" },
  { value: "rapport_comptable", label: "Rapport comptable" },
  { value: "note_interne", label: "Note interne" },
  { value: "autre", label: "Autre document" },
];
export const qcDocTypeLabel = (v) => QC_DOC_TYPES.find((d) => d.value === v)?.label || v;

export const CONTRACT_TYPES = [
  { value: "cdi", label: "CDI" },
  { value: "cdd", label: "CDD" },
  { value: "stage", label: "Stage" },
  { value: "consultant", label: "Consultant" },
];
export const contractLabel = (v) => CONTRACT_TYPES.find((c) => c.value === v)?.label || v || "—";

export const MARITAL_STATUS = [
  { value: "celibataire", label: "Célibataire" },
  { value: "marie", label: "Marié(e)" },
  { value: "divorce", label: "Divorcé(e)" },
  { value: "veuf", label: "Veuf / Veuve" },
];
export const maritalLabel = (v) => MARITAL_STATUS.find((m) => m.value === v)?.label || v || "—";

export const CURRENCIES = [
  { value: "XAF", label: "XAF (FCFA)" },
  { value: "EUR", label: "EUR (€)" },
];
